import React from 'react'
import { Button, Form, Input } from 'antd'
import { useHistory } from 'react-router-dom'
import API from 'api'
import { saveUser } from 'reducers/user'
import { newUser } from 'api/user'
import { useDispatch } from 'react-redux'
import { USER_INFO } from 'api/constants'
import { UserOutlined, LockOutlined } from '@ant-design/icons'

const PasswordForm = () => {
  const [loginForm] = Form.useForm()
  const history = useHistory()
  const dispatch = useDispatch()

  const loginWithPassword = values => {
    values.type = 'password'
    API.Login(values).then(res => {
      console.log(res);

      switch (res.code) {
        case 1002:
          loginForm.setFields([{ errors: ['用户不存在'], name: 'username' }])
          sessionStorage.removeItem(USER_INFO)
          break
        case 1005:
          loginForm.setFields([{ errors: ['密码错误'], name: 'password' }])
          sessionStorage.removeItem(USER_INFO)
          break
        default:
          if (res.data.type === "student") {
            loginForm.setFields([{ errors: ['学生用户无法登录'], name: 'username' }])
            sessionStorage.removeItem(USER_INFO)
            sessionStorage.clear()
            dispatch(saveUser(newUser()))
          } else {
            dispatch(saveUser(res.data))
            history.push('/home')
          }
          break
      }
    })
  }

  const retrievePassword = () => {
    history.push('/retrieve/query')
  }

  const register = () => {
    history.push('/register/query')
  }

  return (
    <>
      <Form
        onFinish={loginWithPassword}
        form={loginForm}
        initialValues={{ username: '', password: '' }}
      >
        <Form.Item name="username" rules={[{ required: true, message: '请输入正确的用户名' }]}>
          <Input
            size="large"
            className="login-input"
            placeholder="账号/手机号"
            prefix={<UserOutlined style={{ color: '#BFBFBF' }} />}
            allowClear
          />
        </Form.Item>

        <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
          <Input.Password
            size="large"
            className="login-input"
            placeholder="密码"
            prefix={<LockOutlined style={{ color: '#BFBFBF' }} />}
            autoComplete="password"
          />
        </Form.Item>

        <div className="login-inner">
          <div>
            <Button type="link" onClick={register}>
              注册账号
            </Button>
          </div>
          <div>
            <Button type="link" onClick={retrievePassword}>
              忘记密码
            </Button>
          </div>
        </div>

        <Form.Item>
          <Button type="primary" htmlType="submit" size="large" className="login-form-button">
            登录
          </Button>
        </Form.Item>
      </Form>
    </>
  )
}

export default PasswordForm
